import { Component } from '@angular/core';
import { BaseInlineUpdateComponent, InlineContainerService } from 'yt-ng-framework';
import { EOtpremnicaOpasnaMaterija } from './eotpremnica-opasna-materija';

@Component({
  selector: 'yt-eotpremnica-opasna-materija-inline-update',
  templateUrl: './eotpremnica-opasna-materija-inline-update.component.html'
})
export class EOtpremnicaOpasnaMaterijaInlineUpdateComponent
  extends BaseInlineUpdateComponent<EOtpremnicaOpasnaMaterija> {

  constructor(protected inlineContainerService: InlineContainerService<EOtpremnicaOpasnaMaterija>) {
    super(inlineContainerService);
  }

  //  izlazna: boolean = false;
  //  ngAfterViewInit() {
  //     if (this.baseUpdateComponent.modelData)
  //       this.izlazna = this.baseUpdateComponent.modelData.MainList.FormControlDataName == "eotpremnice/uleotpremnicaopasnamaterija";
  // }

}
